// FRONTEND/src/components/UI/MaintenanceBreak.js
import React from "react";
import { Wrench } from "lucide-react";
import { useMaintenance } from "../../contexts/MaintenanceContext";
import { useAuth } from "../../contexts/AuthContext";

export default function MaintenanceBreak() {
  const { maintenance } = useMaintenance();
  const { logout } = useAuth();

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-50 dark:bg-gray-950 p-6 pointer-events-auto">
  <div className="w-full max-w-lg rounded-3xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-xl p-8 pointer-events-auto">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-2xl bg-indigo-600 text-white flex items-center justify-center">
            <Wrench className="h-6 w-6" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100">
              System Maintenance Break
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              The system is temporarily unavailable.
            </p>
          </div>
        </div>

        <div className="mt-5 rounded-2xl bg-gray-50 dark:bg-gray-950/40 border border-gray-200 dark:border-gray-800 p-4">
          <p className="text-sm text-gray-800 dark:text-gray-200">
            {maintenance.message || "We are currently doing maintenance. Please try again later."}
          </p>

          {(maintenance.startsAt || maintenance.endsAt) && (
            <p className="mt-2 text-xs text-gray-600 dark:text-gray-400">
              {maintenance.startsAt ? `Start: ${new Date(maintenance.startsAt).toLocaleString()}` : ""}
              {maintenance.endsAt ? ` • End: ${new Date(maintenance.endsAt).toLocaleString()}` : ""}
            </p>
          )}
        </div>

        <button
            onClick={() => {
                logout();
                window.location.href = "/login";
            }}
            className="mt-6 w-full h-11 rounded-xl bg-indigo-600 text-white font-semibold hover:bg-indigo-700"
            >
            Sign out
        </button>
      </div>
    </div>
  );
}